import { isTablet } from "@customer-tools-web/component-ui";
import * as React from "react";
import styled from "styled-components";

import Hamburger from "../../../assets/hamburger.svg";
import { MenuItemType, TrackMenuType } from "../Header";
import { useDrawer } from "../components/Drawer";
import { useMenus, Menu_Keys_Type } from "../components/Menus";
import { matchActiveKey } from "../components/tool";
import { NotificationBadge } from "../components/NavigatorLink";

interface NavigationMenuProps {
  umServer: string;
  ctServer: string;
  menus: MenuItemType[];
  screenWidth?: number;
  trackMenuTap?: TrackMenuType;
  displayNotificationBadge?: boolean;
  displayMarketWatchTooltip?: boolean;
}
export function NavigationMenu(props: NavigationMenuProps) {
  const { menus } = props;
  const [currentKey, setCurrentKey] = React.useState<Menu_Keys_Type | string>(
    props.menus[0].key || ""
  );
  const [hideSubMenuKey, setHideSubMenuKey] = React.useState<string>("");

  // Prevent submenu from opening when hovering over the tooltip because it is nested inside the menu title
  // By preventing hover on the tooltip, we avoid unintentional opening of the submenu
  const onSubMenuTitleMouseEnter = (e: any) => {
    const target = e.domEvent.target;
    const className = target.className;

    const disableListingHoverForTooltip =
      ["listings"].includes(e.key) && className.indexOf("StaticTooltip") > -1;

    if (props.displayMarketWatchTooltip) {
      setHideSubMenuKey("search-properties");
    } else if (disableListingHoverForTooltip) {
      setHideSubMenuKey(e.key);
    } else {
      setHideSubMenuKey("");
    }
  };

  React.useEffect(() => {
    const matched = matchActiveKey(menus);
    if (matched !== currentKey) {
      setCurrentKey(matched);
    }
  });

  const { renderDrawer, showDrawer, closeDrawer, isDrawerOpen } = useDrawer();
  const { renderMenus, renderButtons } = useMenus();
  const { trackMenuTap, screenWidth } = props;
  const trackMenuTapWithCurrentUrl = (
    (currentUrl: string) => (menuName: MenuItemType["key"]) =>
      trackMenuTap && trackMenuTap(menuName, currentUrl)
  )(window.location.pathname);
  return isTablet(screenWidth!)
    ? renderDraw()
    : renderMenus({
        currentKey,
        menus,
        mode: "horizontal",
        onClick,
        onSubMenuTitleMouseEnter,
        hideSubMenuKey,
      });

  function onClick(key: Menu_Keys_Type, close: boolean = true) {
    trackMenuTapWithCurrentUrl(key);
    if (close) {
      closeDrawer();
    }
  }

  function renderDraw() {
    const defaultOpenKeys: Menu_Keys_Type[] = [];
    if (props.displayNotificationBadge) {
      defaultOpenKeys.push("search-properties");
    }

    return (
      <>
        <SidebarButton data-test="mobile-nav-menu-button" onClick={showDrawer}>
          {props.displayNotificationBadge && (
            <NotificationBadge dot={true} color={"#C20000"} offset={[10, -7]} />
          )}
          <SidebarIcon
            data-test="hamburger-icon"
            dangerouslySetInnerHTML={{ __html: Hamburger }}
          />
        </SidebarButton>
        {renderDrawer({
          footer: (
            <ButtonGroup>
              {renderButtons({
                onClick,
                menus: props.menus,
              })}
            </ButtonGroup>
          ),
          children: renderMenus({
            currentKey,
            menus,
            mode: "inline",
            onClick,
            isDrawerOpen,
            defaultOpenKeys,
          }),
        })}
      </>
    );
  }
}

const SidebarButton = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  height: 24px;
  width: 24px;
  cursor: pointer;
`;

const SidebarIcon = styled.div`
  width: 100%;
  height: 100%;
  svg {
    width: 100%;
    height: 100%;
  }
`;
const ButtonGroup = styled.div`
  padding: 0 22px;
  margin-bottom: 22px;
`;

export default NavigationMenu;
